module.exports = __webpack_public_path__ + "static/media/bts.ed5e75cb.png";